import { FC } from 'react'
import { Box, IconButton, Typography } from '@mui/material'

import DeleteIcon from '@mui/icons-material/Delete'
import { Charges, WEIGHT_CHARGE_ITEM_TYPE } from '../../../services'

type PreviewAddOtherChargesProps = {
  charge: Charges
  deleteCharge: () => void
}

const PreviewAddOtherCharges: FC<PreviewAddOtherChargesProps> = ({
  charge,
  deleteCharge,
}) => {
  function getId(field: string) {
    return `id_${charge?.chargeTitle}_${charge.amount}_${field}`
  }

  const isWeightCharge = charge?.itemType === WEIGHT_CHARGE_ITEM_TYPE

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
        gap: 2,
        width: '100%',
        py: 0.5,
      }}
    >
      <Typography data-cy={getId('title')} sx={{ flex: 1, minWidth: 0 }} noWrap>
        {charge?.chargeTitle}
      </Typography>

      {!isWeightCharge && (
        <Typography data-cy={getId('amount')} sx={{ flexShrink: 0 }}>
          {charge?.amount}
        </Typography>
      )}

      {charge?.hsnCode != null && charge.hsnCode !== '' && (
        <Typography data-cy={getId('hsnCode')} sx={{ flexShrink: 0 }}>
          SAC: {charge.hsnCode}
        </Typography>
      )}

      {isWeightCharge && (
        <>
          <Typography data-cy={getId('quantity')} sx={{ flexShrink: 0 }}>
            Qty: {charge?.quantity}
          </Typography>
          <Typography data-cy={getId('rate')} sx={{ flexShrink: 0 }}>
            Rate: {charge?.rate}
          </Typography>
        </>
      )}

      <IconButton
        data-cy={getId('button_delete')}
        sx={{
          flexShrink: 0,
          backgroundColor: 'rgb(255, 0, 0, 0.2)',
          color: 'crimson',
        }}
        size="small"
        onClick={deleteCharge}
      >
        <DeleteIcon />
      </IconButton>
    </Box>
  )
}

export default PreviewAddOtherCharges
